import { type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore, selectIsAuthenticated } from "@/stores/authStore";

/**
 * Inverse of ProtectedRoute: if the user is already authenticated, bounce
 * them to / (Dashboard) instead of showing the login/forgot-password page.
 */
export default function PublicOnlyRoute({ children }: { children: ReactNode }) {
  const isAuthenticated = useAuthStore(selectIsAuthenticated);
  if (isAuthenticated) return <Navigate to="/" replace />;
  return <>{children}</>;
}
